const toArray = value => value === undefined || value === null
    ? []
    : (Array.isArray(value) ? value : [value]);

const buildActionLookup = ({header, footer, unlinked, productCategories, actionLookup} = {}) => {
    const lookup = {};

    const visit = (item) => {
        if (!item || typeof item !== 'object') return;

        if (item.action?.type === 'link' || item.action?.type === 'page') {
            [
                item._id,
                item.uuid,
                item.uniqueUri,
                item.action?.uniqueUri,
                item.linkedNode?.uuid,
                item.linkedNode?.uniqueUri
            ]
                .filter(Boolean)
                .forEach(identity => lookup[identity] = item.action.value);
        } else if (item.nodeType === 'ProductCategory') {
            [item._id, item.id, item.uuid, item.uniqueUri]
                .filter(Boolean)
                .forEach(identity => lookup[identity] = item.uri);
        }

        toArray(item.children?.length ? item.children : item.items).forEach(visit);
    };

    [header?.items, footer?.items, unlinked?.items || unlinked, productCategories?.items || productCategories]
        .forEach(items => toArray(items).forEach(visit));

    // Page metadata is authoritative. Menu copies provide useful compatibility
    // aliases, but must not overwrite the current route for a referenced page.
    return {...lookup, ...(actionLookup || {})};
};

module.exports = buildActionLookup;
